/**
 * iter 373 — GlobalStaffAttendanceGate
 *
 * Mount-once wrapper that fetches the caller's role and mounts the blocking
 * attendance gate for in-scope roles. Hidden entirely on /login,
 * /auth/callback, and portal roots when not applicable.
 */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import StaffAttendanceGate from './StaffAttendanceGate';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const HIDDEN_PATHS = ['/', '/login', '/auth/callback'];

let cachedRole = null;
let cacheTs = 0;

export default function GlobalStaffAttendanceGate() {
  const [role, setRole] = useState(cachedRole);
  const location = useLocation();

  useEffect(() => {
    const now = Date.now();
    if (cachedRole && now - cacheTs < 5 * 60 * 1000) { setRole(cachedRole); return; }
    axios.get(`${API_URL}/api/auth/me`, { withCredentials: true })
      .then(r => { cachedRole = r.data?.role || null; cacheTs = Date.now(); setRole(cachedRole); })
      .catch(() => { cachedRole = null; setRole(null); });
  }, [location.pathname]);

  if (!role) return null;
  if (HIDDEN_PATHS.some(p => location.pathname === p || location.pathname.startsWith('/login'))) return null;
  return <StaffAttendanceGate role={role} />;
}
